__turbopack_context__.v({
  "aboucontentborder": "about-module__GPGXgq__aboucontentborder",
  "aboutbox": "about-module__GPGXgq__aboutbox",
  "aboutbox1": "about-module__GPGXgq__aboutbox1",
  "acheivername": "about-module__GPGXgq__acheivername",
  "acheiverrank": "about-module__GPGXgq__acheiverrank",
  "governmentname": "about-module__GPGXgq__governmentname",
  "greybackground": "about-module__GPGXgq__greybackground",
  "img": "about-module__GPGXgq__img",
  "missionbg": "about-module__GPGXgq__missionbg",
  "pagemaintitle": "about-module__GPGXgq__pagemaintitle",
  "sectionsubtitle": "about-module__GPGXgq__sectionsubtitle",
  "sectiontitle": "about-module__GPGXgq__sectiontitle",
  "visionbg": "about-module__GPGXgq__visionbg",
});
